import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
} from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import PriceContext from '../../../../shared/contexts/PriceContext'
import { EclipseStep } from '../../../../shared/components/StepIcon'
import {
  useAlert,
} from '../../../../shared/components'

import Insured from './fragments/Insured'
import Requester from './fragments/Requester'
import FileUpload from './fragments/FileUpload'
import ObjectProperty from './fragments/ObjectProperty'
import StepperQuotation from '../StepperQuotation'

import InsuredData from '../../../../models/JudicialGuaranteeCivelModels/InsuredData'
import PolicyHolderData from '../../../../models/JudicialGuaranteeCivelModels/PolicyHolderData'
import ClaimantData from '../../../../models/JudicialGuaranteeCivelModels/ClaimantData'
import RequesterData from '../../../../models/JudicialGuaranteeCivelModels/RequesterData'
import FileUploadData from '../../../../models/JudicialGuaranteeCivelModels/FileUploadData'
import ObjectPropertyData from '../../../../models/JudicialGuaranteeCivelModels/ObjectPropertyData'

const StepType = {
  INSURED: 0,
  OBJECT_PROPERTY: 1,
  REQUESTER: 2,
  FILE_UPLOAD: 3,
}

const JudicialGuaranteeCivel = () => {
  const history = useHistory()

  const { state } = useLocation()

  const { Provider } = PriceContext

  const { addMsgDanger: addMsgError, addMsgSuccess } = useAlert()
  const { addMsgDanger, cleanMsg } = useAlert('register')

  const [steps] = useState([
    StepType.INSURED,
    StepType.OBJECT_PROPERTY,
    StepType.REQUESTER,
    StepType.FILE_UPLOAD,
  ])
  const [stepsRef, setStepsRef] = useState({})
  const [actionNext, setActionNext] = useState(false)
  const [quoteEditData, setQuoteEditData] = useState({})
  const [actionPrevious, setActionPrevious] = useState(false)
  const [isFormikChanged, setIsFormikChanged] = useState(false)
  const [activeStep, setActiveStep] = useState(StepType.INSURED)
  const [judicialGuaranteeCivel, setJudicialGuaranteeCivel] = useState({})

  const [namePolicyHolder, setNamePolicyHolder] = useState('')
  const [resourceTypeProduct, setResourceTypeProduct] = useState('')

  const InsuredRef = useRef()
  const RequesterRef = useRef()
  const FileUploadRef = useRef()
  const ObjectPropertyRef = useRef()

  const setDataCamelCase = useCallback((quote) => {
    setJudicialGuaranteeCivel({
      requester: RequesterData(quote?.Requester),
      insured: InsuredData(quote?.Insured),
      policyHolder: PolicyHolderData(quote?.PolicyHolder),
      claimant: ClaimantData(quote?.Claimant),
      objectProperty: ObjectPropertyData(quote?.ObjectProperty),
      fileUpload: FileUploadData(quote?.FileUpload),

    })
  }, [setJudicialGuaranteeCivel])

  useEffect(() => {
    if (state?.quote) {
      setDataCamelCase({ ...state?.quote })
      setQuoteEditData({ ...state?.quote })
      setActiveStep(steps[steps.length - 1])
    }
  }, [state?.quote, steps, setActiveStep, setQuoteEditData, setDataCamelCase])

  useEffect(() => {
    const stepsControl = {}
    stepsControl[StepType.INSURED] = InsuredRef
    stepsControl[StepType.REQUESTER] = RequesterRef
    stepsControl[StepType.FILE_UPLOAD] = FileUploadRef
    stepsControl[StepType.OBJECT_PROPERTY] = ObjectPropertyRef

    setStepsRef(stepsControl)
  }, [
    setStepsRef,
    InsuredRef,
    RequesterRef,
    FileUploadRef,
    ObjectPropertyRef,
  ])

  const isActiveStep = (step) => activeStep === step

  const handleNext = () => {
    const stepRef = stepsRef[activeStep]
    stepRef.current.onSubmit().then((data) => {
      if (data) {
        addMsgDanger(data)
      } else {
        setActionNext(true)
        setActionPrevious(false)
      }
    })
  }

  const onNext = () => {
    cleanMsg()
    if (steps.includes(activeStep + 1)) {
      setActiveStep(activeStep + 1)
    }
  }

  const onPrevious = () => {
    cleanMsg()
    setActiveStep(activeStep - 1)
  }

  const onEdit = (step) => {
    setActiveStep(step)

    cleanMsg()
    setActionNext(false)
    setActionPrevious(true)
  }

  const onRegister = (data) => {
    const dataSuccess = {
      title: data?.Title,
      message: data?.Message,
      labelButton: 'Acompanhe sua cotação',
      action: () => history.replace(`/cotacao/${data?.Identifier}/status`),
    }

    addMsgSuccess(dataSuccess)
  }

  const handleRegister = () => {
    const stepRef = stepsRef[activeStep]
    stepRef.current.onSubmit().then((data) => {
      addMsgError(data)
      if (!data) {
        onEdit(StepType.REQUESTER)
      }
    })
  }

  const setFormikChanged = (isChanged) => {
    if (!isFormikChanged) {
      setIsFormikChanged(isChanged)
    }
  }

  return (
    <Provider value={{
      judicialGuaranteeCivel,
      setJudicialGuaranteeCivel,
      resourceTypeProduct,
      setResourceTypeProduct,
      actionNext,
      actionPrevious,
      onNext,
      onRegister,
      addMsgError,
      namePolicyHolder,
      setNamePolicyHolder,
      isFormikChanged,
      setFormikChanged,
    }}
    >
      {/* STEPS */}
      <StepperQuotation steps={steps} EclipseStep={EclipseStep} activeStep={activeStep} />

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Insured
            quote={quoteEditData}
            ref={stepsRef[StepType.INSURED]}
            checked={isActiveStep(StepType.INSURED)}
            handleNext={handleNext}
            handlePrevious={() => history.goBack()}
            handleStep={() => onEdit(StepType.INSURED)}
          />
        </Grid>
        <Grid item xs={12}>
          <ObjectProperty
            quote={quoteEditData}
            ref={stepsRef[StepType.OBJECT_PROPERTY]}
            checked={isActiveStep(StepType.OBJECT_PROPERTY)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={() => onEdit(StepType.OBJECT_PROPERTY)}
          />
        </Grid>
        <Grid item xs={12}>
          <Requester
            quote={quoteEditData}
            ref={stepsRef[StepType.REQUESTER]}
            checked={isActiveStep(StepType.REQUESTER)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={() => onEdit(StepType.REQUESTER)}
          />
        </Grid>
        <Grid item xs={12}>
          <FileUpload
            quote={quoteEditData}
            ref={stepsRef[StepType.FILE_UPLOAD]}
            checked={isActiveStep(StepType.FILE_UPLOAD)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={handleRegister}
          />
        </Grid>
      </Grid>
    </Provider>
  )
}

export default JudicialGuaranteeCivel
